/**
 * Vendor cards show a short description plus hours and insurance.
 * The listing disclaimer stays on the terms, privacy policy, disclaimers,
 * and the one-time vendor acknowledgement. It is not part of a vendor card.
 */

const { PACARION_NO_VENDOR_PAYMENT } = require('./vendorConsent');

// Appended to descriptions before 2026-10-16. Quoted only so stored rows
// can drop it. Legal pages never used this sentence.
const RETIRED_LISTING_DISCLAIMER =
  "Vendors don't pay Pacarion to be listed, and Pacarion doesn't receive referral fees or compensation from them.";

const LISTING_DISCLAIMERS = [PACARION_NO_VENDOR_PAYMENT, RETIRED_LISTING_DISCLAIMER];

const DETAIL_MARK = /Hours:|Insurance:|License:|Not available after storms\.|Available after storms\./g;

function stripVendorListingDisclaimer(value) {
  let text = String(value == null ? '' : value).replace(/\r\n/g, '\n');
  LISTING_DISCLAIMERS.forEach((needle) => {
    if (!needle) return;
    text = text.split(needle).join('');
  });
  text = text
    .split('\n')
    .map((line) => line.replace(/^[ \t]+|[ \t]+$/g, ''))
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
  return text;
}

function listingDisclaimerPresent(value) {
  const text = String(value == null ? '' : value);
  return LISTING_DISCLAIMERS.some((needle) => needle && text.indexOf(needle) !== -1);
}

function splitDetailLine(line) {
  const marks = [];
  const re = new RegExp(DETAIL_MARK.source, 'g');
  let match = re.exec(line);
  while (match) {
    marks.push(match.index);
    match = re.exec(line);
  }
  if (!marks.length) return { about: line, details: [] };
  const about = line.slice(0, marks[0]).trim();
  const details = [];
  marks.forEach((start, index) => {
    const end = index + 1 < marks.length ? marks[index + 1] : line.length;
    const piece = line.slice(start, end).trim();
    if (piece) details.push(piece);
  });
  return { about, details };
}

function presentVendorCardCopy(value) {
  const cleaned = stripVendorListingDisclaimer(value);
  const about = [];
  const details = [];
  cleaned.split('\n').forEach((raw) => {
    const line = raw.trim();
    if (!line) return;
    const split = splitDetailLine(line);
    if (split.about) about.push(split.about);
    split.details.forEach((detail) => details.push(detail));
  });
  return { about: about.join('\n'), details };
}

function dollarQuote(value) {
  return '$pacarion$' + value + '$pacarion$';
}

function descriptionExpression() {
  const current = dollarQuote(PACARION_NO_VENDOR_PAYMENT);
  const retired = dollarQuote(RETIRED_LISTING_DISCLAIMER);
  return [
    'nullif(',
    '  btrim(',
    '    regexp_replace(',
    '      regexp_replace(',
    '        replace(replace(description, ' + current + ', \'\'), ' + retired + ', \'\'),',
    '        E\'[ \\t]*\\n[ \\t]*\',',
    '        E\'\\n\',',
    '        \'g\'',
    '      ),',
    '      E\'\\n{3,}\',',
    '      E\'\\n\\n\',',
    '      \'g\'',
    '    ),',
    '    E\' \\t\\n\'',
    '  ),',
    '  \'\'',
    ')',
  ].join('\n');
}

function updateTable(table) {
  return [
    'update public.' + table,
    'set description = ' + descriptionExpression().replace(/^/gm, '  ').trim(),
    'where strpos(description, \'does not receive referral fees, commissions\') > 0',
    '   or strpos(description, \'pay Pacarion to be listed\') > 0;',
  ].join('\n');
}

function vendorDisclaimerCleanupSql() {
  return [
    '-- Strip the vendor-listing disclaimer from vendor descriptions.',
    '-- Hours, insurance, license, and the vendor\'s own words stay.',
    '--',
    '-- Pacarion Development (ftrhhpaduufkjfkjwzru): safe for the dev cleanup.',
    '-- Pacarion App (zvnubjrizoiwrzrhunjz): a person runs this on LIVE.',
    '-- Do not run it on LIVE from CI or from a cloud agent.',
    '-- Legal pages, consent logs, and terms are not in these tables.',
    '',
    updateTable('vendors'),
    '',
    updateTable('regional_vendors'),
    '',
  ].join('\n');
}

module.exports = {
  RETIRED_LISTING_DISCLAIMER,
  LISTING_DISCLAIMERS,
  stripVendorListingDisclaimer,
  listingDisclaimerPresent,
  presentVendorCardCopy,
  vendorDisclaimerCleanupSql,
};
